import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	responses: null,
    localRespondent: null
};

export const misSurveySlice = createSlice({
	name: "misSurvey",
	initialState,
	reducers: {
		setResponses: (state, { payload }) => {
			const { currentSection, formData } = payload;
			return {
				...state,
				responses: {
					...state.responses,
					[currentSection]: formData,
				},
			};
		},
		setRespondent: (state, { payload }) => {
			return {
				...state,
				localRespondent: payload,
			};
		},
		resetState: (state) => {
			return { ...state, responses: null, localRespondent: null };
		},
	},
});

export const { setResponses, setRespondent, resetState } = misSurveySlice.actions;

export default misSurveySlice.reducer;
